import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import light from './vuetify/theme';
import dark from './vuetify/theme';
import { TiptapVuetifyPlugin } from 'tiptap-vuetify';
import 'tiptap-vuetify/dist/main.css';
import i18n from '../plugins/i18n';

Vue.use(Vuetify);

const vuetify = new Vuetify({
    theme: {
        themes: {
            light,
            dark,
        },
    },
    lang: {
        t: (key, ...params) => i18n.t(key, params),
        tc: (key, ...params) => i18n.tc(key, params),
    },
});

Vue.use(TiptapVuetifyPlugin, {
    vuetify,
    iconsGroup: 'mdi',
});

export default vuetify;
